import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import env from "../enviorments";
import header from "../header";
Vue.use(Vuex);

const api = axios.create({
  baseURL: env.apiUrl,
  headers: header.getToken(),
});

// ✅ Interceptor to catch 401 or other errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 404) {
        //console.error("❌ 404 - Not Found:", error.response.config.url);
        // Example: redirect to a Not Found page
        //window.location.href = "/dashboard";
      } else if (status === 401) {
        console.warn("🔒 Unauthorized, clearing session...");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("user");
        window.location.href = "/login";
      } else {
        console.error(`⚠️ API Error [${status}]:`, error.response.data);
      }
    } else {
      console.error("🚨 Network error or server unreachable", error.message);
    }

    // Reject so that component actions can still handle it if needed
    return Promise.reject(error);
  },
);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
  },
  getters: {},
  mutations: {
    mutateUser(state, user) {
      state.user = user;
    },
    mutateToken(state, token) {
      state.token = token;
    },
  },
  actions: {
    //Auth
    async userLogin({ commit }, user) {
      const result = (await api.post("auth/authenticate", { ...user })).data;
      if (result.success == false)
        return { success: false, data: [], message: result.message, error: [] };
      window.localStorage.setItem("token", JSON.stringify(result.result.token));
      window.localStorage.setItem("user", JSON.stringify(result.result.agent));
      commit("mutateToken", result.result.token);
      commit("mutateUser", result.result.agent);

      return {
        success: true,
        data: result.result.agent,
        message: "login is success.",
        error: [],
      };
    },
    //Dashboard
    async dashboardAction({ commit }, option) {
      const result = (
        await api.get(
          `account/dashboard?type=${option.type}&startDate=${option.from}&endDate=${option.to}`,
          {
            headers: header.getToken(),
          },
        )
      ).data;
      if (result.success == false)
        return { success: false, data: [], message: result.message, error: [] };
      return {
        success: true,
        data: result.result,
        message: "Success",
        error: [],
      };
    },
    //Promotion
    async promotionListAction({ commit }, option) {
      const result = (
        await api.get(
          `promo-tickets/index?per_page=${option.per_page}&page=${
            option.page
          }&status=${option.status === true ? 1 : 0}`,
          {
            headers: header.getToken(),
          },
        )
      ).data;
      if (result.success === false) {
        return { success: false, data: [], message: result.message, error: [] };
      }
      return {
        success: true,
        data: result.result,
        message: "Success",
        error: [],
      };
    },
    async promotionDetailAction({ commit }, option) {
      const responseData = (
        await api.get(`promo-tickets/show/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async promotionEditAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios PUT request
        const result = await api.post(
          `promo-tickets/update/${option.get("id")}`,
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async promotionStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("promo-tickets/store", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async promotionDeleteAction({ commit }, option) {
      const responseData = (
        await api.delete(`promo-tickets/delete/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    //UTM
    async utmListAction({ commit }, option) {
      const result = (
        await api.get(
          `/utm-keywords/index?per_page=${option.per_page}&page=${option.page}`,
          {
            headers: header.getToken(),
          },
        )
      ).data;
      if (result.success === false) {
        return { success: false, data: [], message: result.message, error: [] };
      }
      return {
        success: true,
        data: result.result,
        message: "Success",
        error: [],
      };
    },
    async utmEditAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios PUT request
        const result = await api.post(`/utm-keywords/update`, option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async utmStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("utm-keywords/store", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async utmDeleteAction({ commit }, option) {
      const responseData = (
        await api.delete(`utm-keywords/delete/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },

    //Banner
    async bannerListAction({ commit }, option) {
      const result = (
        await api.get(
          `/banners/index?per_page=${option.per_page}&page=${
            option.page
          }&status=${option.status === true ? 1 : 0}`,
          {
            headers: header.getToken(),
          },
        )
      ).data;
      if (result.success === false) {
        return { success: false, data: [], message: result.message, error: [] };
      }
      return {
        success: true,
        data: result.result,
        message: "Success",
        error: [],
      };
    },
    async bannerDetailAction({ commit }, option) {
      const responseData = (
        await api.get(`banners/show/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async bannerEditAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios PUT request
        const result = await api.post(
          `banners/update/${option.get("id")}`,
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async bannerStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("banners/store", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async bannerDeleteAction({ commit }, option) {
      const responseData = (
        await api.delete(`banners/delete/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    // Master List
    async masterListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/master-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    //Agent List
    async agentListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/agent-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },

    async agentStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("account/add-agent", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async agentDetailAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/agent-details",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },

    async agentUpdateAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("account/update-agent", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async agentDeleteAction({ commit }, option) {
      const result = (
        await api.post(
          "agent-delete",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (result.status == false)
        return { status: "fail", data: [], message: result.message, error: [] };
      return {
        status: "success",
        data: result.data,
        message: "Success",
        error: [],
      };
    },

    //Bank Info
    async paymentMethodAction({ commit }) {
      const responseData = (
        await api.get("admin-bank-infos/get-payment-methods", {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async paymentAction({ commit }) {
      const responseData = (
        await api.get("admin-bank-infos/get-payments", {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async bankListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-bank-infos/get-bank-infos",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async bankStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post(
          "admin-bank-infos/add-bank-info",
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async bankDetailAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-bank-infos/bank-info-details",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },

    async bankUpdateAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post(
          "admin-bank-infos/update-bank-info",
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async bankDeleteAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-bank-infos/delete-bank-info",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.data,
        message: "Success",
        error: [],
      };
    },
    // Deposit
    async checkDepositAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/check-deposit",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async checkWithdrawAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/check-withdraw",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async depositListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/deposit-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async depositStoreAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("admin-coins/deposit-create", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async promoTicketDepositList({ commit }, option) {
      const responseData = (
        await api.get(
          "promo-tickets/index?purpose=Deposit&status=1",
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success:true,
        data:responseData.result,
        message:"Success",
        error:[]
      }  
    },
    async depositStatusCompletedAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/approve-deposit",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.data,
        message: "Success",
        error: [],
      };
    },
    async depositStatusFailedAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/reject-deposit",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.data,
        message: "Success",
        error: [],
      };
    },
    // Withdraw
    async withdrawListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/withdraw-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async withdrawStatusCompletedAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/approve-withdraw",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.data,
        message: "Success",
        error: [],
      };
    },
    async withdrawStatusFailedAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/reject-withdraw",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.response.data.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.data,
        message: "Success",
        error: [],
      };
    },
    async agentWithdrawListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/agent-withdraw-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async approveAgentWithdrawAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/approve-agent-withdraw",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async rejectAgentWithdrawListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "admin-coins/reject-agent-withdraw",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    // Member
    async memberListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/user-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async agentMemberListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "agents/user-lists",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async updateUserPasswordAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/update-user-password",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async updateUserPinAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/update-user-pin",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async checkUserAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/check-user",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    //Notification
    async notiListAction({ commit }, option) {
      console.log(option, "307");
      const responseData = (
        await api.get("notifications/index", {
          params: option,
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async notiDetailAction({ commit }, option) {
      const responseData = (
        await api.get(`notifications/show/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async notiDeleteAction({ commit }, option) {
      console.log(option, "Option");
      const responseData = (
        await api.delete(`notifications/delete/${option.id}`, {
          headers: header.getToken(),
        })
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async notiEditAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios PUT request
        const result = await api.post(
          `notifications/update/${option.get("id")}`,
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        console.error("Error in Store Action:", error);
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async notiStoreIndividualAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post(
          "notifications/store-individual",
          option,
          {
            headers: {
              ...header.getToken(),
              "Content-Type": "multipart/form-data",
            },
          },
        );

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },

    async notiStoreAllAction({ commit }, option) {
      try {
        // Check if option is a FormData object
        if (!(option instanceof FormData)) {
          throw new Error("Option is not a FormData object");
        }

        // Proceed with axios POST request
        const result = await api.post("notifications/store-all", option, {
          headers: {
            ...header.getToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        return {
          success: true,
          data: result.data,
          message: "Success",
          error: [],
        };
      } catch (error) {
        return {
          success: false,
          data: [],
          message: error.response.data.message,
          error: [error],
        };
      }
    },
    async notiSendAction({ commit }, option) {
      const responseData = (
        await api.post(
          `notifications/send/${option.id}`,
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      console.log(responseData, "933");
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    // Report
    async dailyReportListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/daily-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async agentReportListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/agent-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async memberReportListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "account/member-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async memberWinLoseReportListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "account/member-winlose-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async agentDailyReportListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "agents/daily-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async agentMemberReportListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "agents/member-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async agentMemberWinLoseReportListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "agents/member-winlose-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async dailyNMReportListAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/daily-nm-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async memberNMReportListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "account/member-nm-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    // Total Summary
    async totalAgentSummary({ commit }, option) {
      const responseData = (
        await api.post(
          "account/total-agent-summary",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async totalMemberMasterSummary({ commit }, option) {
      const responseData = (
        await api.post(
          "account/total-member-master-summary",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async totalDailyMasterSummary({ commit }, option) {
      const responseData = (
        await api.post(
          "account/total-daily-master-summary",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async totalDailyNMReportSummary({ commit }, option) {
      const responseData = (
        await api.post(
          "account/total-daily-nm-summary",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async totalMemberNMSummary({ commit }, option) {
      const responseData = (
        await api.post(
          "account/total-member-nm-summary",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    //Utm Report
    async getUserUtmReportAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/user-utm-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    //User Activity
    async getUserActivityAction({ commit }, option) {
      const responseData = (
        await api.post(
          "account/user-activity-report",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    // Setting
    async getAllLeaguesAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/get-leagues",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async handicapListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/for-handicap",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async accumulatorListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/for-accumulator",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async fixtureCancelAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/cancel",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async finishedListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/finished",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async rollBackAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/rollback",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async ongoingListAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/not-started",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async updateFinishedAction({ commit }, option) {
      console.log("Option:", option);
      const responseData = (
        await api.post(
          "fixtures/update-finished",
          { ...option },
          { headers: header.getToken() },
        )
      ).data;
      if (responseData.success == false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
    async getShareData({ commit }, option) {
      //admin/account/get-share-data/3302
      const responseData = (
        await api.post(`/account/get-share-data/${option.id}`)
      ).data;
      if (responseData.success === false)
        return {
          success: false,
          data: [],
          message: responseData.message,
          error: [],
        };
      return {
        success: true,
        data: responseData.result,
        message: "Success",
        error: [],
      };
    },
  },
  modules: {},
});
